import {
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  HStack,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import baseUrl from "../vars";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect, useState } from "react";
import {
  ensureAuthenticated,
  getStoredEmail,
  saveLoginSession,
} from "../auth/auth";

const LoginForm = observer(() => {
  const { pageStore } = useStores();
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  // email из localStorage если раньше был "Запомнить пароль"
  const initialValues = {
    email: getStoredEmail() || "",
    password: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().required("Обязательное поле"),
    password: Yup.string().required("Обязательное поле"),
  });

  const [isChecked, setIsChecked] = useState(
    Boolean(localStorage.getItem("refresh_token"))
  );

  useEffect(() => {
    // Если refresh_token сохранён ("Запомнить пароль") - автоматически входим без формы
    const tryRestoreSession = async () => {
      const authenticated = await ensureAuthenticated();
      if (!authenticated) return;

      const target =
        window.location.pathname === "/"
          ? "/openProfit" // как после обычного входа
          : window.location.pathname;
      navigate(target, { replace: true });
    };

    tryRestoreSession();
  }, [navigate]);

  const handleSubmit = async (values) => {
    setLoading(true);
    const response = await fetch(`${baseUrl}/api/auth`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    if (response.ok) {
      const result = await response.json();
      // remember = галочка "Запомнить пароль"
      saveLoginSession({
        jwt_token: result?.jwt_token,
        refresh_token: result?.refresh_token,
        email: values?.email,
        remember: isChecked,
      });
      navigate("/openProfit");
    } else if (response.status == 403) {
      toast({
        title: "Ошибка",
        status: "error",
        description: "Неправильный логин или пароль",
        isClosable: true,
        duration: "3000",
      });
    } else if (response.status == 404) {
      toast({
        title: "",
        status: "success",
        description: "Пароль отправлен в Bitrix24",
        isClosable: true,
        duration: "3000",
      });
    } else {
      toast({
        title: "Ошибка",
        status: "error",
        description: "Неправильный логин или пароль",
        isClosable: true,
        duration: "3000",
      });
    }
    await pageStore.CheckPermission("export excel");
    setLoading(false);
  };

  const forgotPassword = async (values) => {
    const response = await fetch(
      `${baseUrl}/api/auth/forgot?email=${values?.email}`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
        },
      }
    );
    if (response.ok) {
      toast({
        description: "Проверьте свой Битрикс",
        status: "info",
      });
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <Form
          style={{
            padding: 0,
            margin: 0,
          }}
        >
          <VStack
            width={"375px"}
            padding={"20px"}
            borderRadius={"16px"}
            align={"flex-start"}
            gap={"10px"}
            bg="#1e1e1e"
          >
            <Text
              color={"myColor.white"}
              fontSize={"22px"}
              fontWeight={"600"}
              alignSelf={"center"}
            >
              Авторизация
            </Text>
            <FormControl isInvalid={errors?.email && touched?.email}>
              <HStack>
                <Text
                  fontSize={"16px"}
                  color={"white"}
                  fontWeight={"500"}
                  minWidth={"70px"}
                >
                  Email
                </Text>
                <Input
                  bg={"#333"}
                  _placeholder={{ color: "white" }}
                  borderColor={"#333"}
                  name="email"
                  color={"white"}
                  width={"100%"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </HStack>

              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors?.email}</Text>
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors?.password && touched?.password}>
              <HStack>
                <Text
                  fontSize={"16px"}
                  color={"white"}
                  fontWeight={"500"}
                  minWidth={"70px"}
                >
                  Пароль
                </Text>
                <Input
                  bg={"#333"}
                  _placeholder={{ color: "white" }}
                  borderColor={"#333"}
                  color={"white"}
                  type="password"
                  name="password"
                  width={"100%"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </HStack>

              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors?.password}</Text>
              </FormErrorMessage>
            </FormControl>
            <HStack width={"100%"} justify={"space-between"} zIndex={2}>
              <Checkbox
                isChecked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                color="white"
              >
                Запомнить пароль
              </Checkbox>
              <Text
                color={"myColor.white"}
                _hover={{ textDecor: "underline" }}
                cursor={"pointer"}
                onClick={async () => forgotPassword(values)}
              >
                Забыли пароль?
              </Text>
            </HStack>
            <HStack width={"100%"} justify={"center"} marginTop={"10px"}>
              <Button
                w={"100%"}
                height={"40px"}
                bg={"rgb(63, 33, 172)"}
                _hover={{ bg: "myColor.darkBlue", color: "myColor.white" }}
                type="submit"
                color={"myColor.white"}
                isLoading={loading}
              >
                Войти
              </Button>
            </HStack>
          </VStack>
        </Form>
      )}
    </Formik>
  );
});

export default LoginForm;
